import { start, app, auth, ui, authInfo, curUser, me, logout, webpushSubscribeUser, webpushCheckSubscription, webpushUnsubscribeUser, getToken } from "/src/firebase.js";
import { collection, doc, getDoc, setDoc, where, getDocs, query, getAggregateFromServer, sum, limit, orderBy, deleteDoc } from "firebase/firestore"
import { getDB, getConfig, pay, payCoffee, createCoffee, getUser, updateBalance, stats, totCoffee, getCredit, getExpenses, deleteCoffee, listCoffee, showCoffee, getDayStats, getAdminStats, saveAdmin, saveExpenses, listUsers, changeColorPod, saveAvatarImg, deleteAvatarImg, showPeopleToOffer } from "/src/data/data.js";
import { getInboxMessages, deleteInboxMessage, updateInboxMessage, addInboxMessage } from "/src/data/inbox.js";
import { saveVersion } from "/src/data/version.js";
import { stats as statsP, KEY_MEMBER, KEY_ADMIN } from "/src/stats.js";
import { showUsers, showSelectUsers, openTab, showDayStats, showBalance, showSection, showAdminTab, showOverlay, hideOverlay } from "/src/navigation.js";
import { CoffeeInfo, COFFEE_INFO_KEY } from "/src/info.js";
import { PRICE, createBoard, help } from '/src/minesweeper.js';
import { startApp, LAST_VER_KEY } from '/src/update.js';
import { t } from '/src/i18n.js';

import { UserList } from '/src/components/user-list.js';
import { PushNotificationComposer } from '/src/components/push-notification-composer.js';
import { ScrollMenu } from '/src/components/scroll-menu.js';
import { CoffeeStats } from '/src/components/coffee-stats.js';
import { TransactionLedger } from '/src/components/transaction-ledger.js';
import { DynamicForm } from '/src/components/dynamic-form.js';
import { CoffeeRanking } from '/src/components/coffee-ranking.js';
import { BottomNav } from '/src/components/bottom-nav.js';
import { UserProfile } from '/src/components/user-profile.js';
import { CoffeeHome } from '/src/components/coffee-home.js';
import { NavRow } from '/src/components/nav-row.js';
import { AvatarPicker } from '/src/components/avatar-picker.js';
import { ReleaseNotes } from '/src/components/release-notes.js';
import { NotificationInbox } from '/src/components/notification-inbox.js';
import { UpdatePrompt } from '/src/components/update-prompt.js';
import { CleanupForm } from '/src/components/cleanup-form.js';

import { getPodImage } from '/src/pods.js';

import jquery from 'jquery';
window.$ = window.jQuery = jquery;
import * as bootstrap from 'bootstrap'
import dayjs from "dayjs";
import { UAParser } from 'ua-parser-js';

import '@fontsource/jura';
import '@fontsource/jura/400.css';
import 'bootstrap/dist/css/bootstrap.min.css'; 
import "/src/css/coffee.css";
import "/src/css/minesweeper.css";

const environment = import.meta.env.VITE_ENV.toLowerCase();

var updateCheckId;
const UPDATE_CHECK_PERIOD_DEFAULT=3600*4*1000;
const UPDATE_CHECK_PERIOD_ADMIN=5000; //5*60*1000;
const COFFEE_THEME_KEY = "COFFEE_THEME";
const COFFEE_CHECK_UPDATE_KEY = "COFFEE_CHECK_UPDATE";

// TODO: FIX DATA 
// remove ADMIN_STATS from localStorage
// read info and create COFFEE_THEME_KEY + COFFEE_CHECK_UPDATE_KEY + COFFEE_SW_LAST_VERSION


function initAdmin() {
    const tabItems = [
      { id:"ex-with-icons-tabs-1", label:"Accredito" },
      { id:"ex-with-icons-tabs-7", label:"Spese" },
      { id:"ex-with-icons-tabs-2", label:"Push" },
      { id:"ex-with-icons-tabs-3", label:"Caffé" },
      { id:"ex-with-icons-tabs-4", label:"Membri" },
      { id:"ex-with-icons-tabs-5", label:"Bilancio" },
      { id:"ex-with-icons-tabs-6", label:"Statistiche" },
    ];
 
    customElements.whenDefined("scroll-menu").then(() => {
      //document.getElementById("mainMenu").items = mainItems;
      document.getElementById("admin-menu").items  = tabItems;

      initTabCredit();
    });
 
    // Listen for menu-select events
    document.addEventListener("menu-select", (e) => {
        console.log("Selected:", e.detail); // { id, label, icon?, badge? }
        let target = e.detail.id;
        showAdminTab(target);

        if (target == "ex-with-icons-tabs-1") {
            initTabCredit();
        } else if (target == "ex-with-icons-tabs-2") {
            initTabPush();
        } else if (target == "ex-with-icons-tabs-3") {
            initTabCoffee();   
        } else if (target == "ex-with-icons-tabs-4") {
            initTabMembers();
        } else if (target == "ex-with-icons-tabs-5") {
            initTabBalance();
        } else if  (target == "ex-with-icons-tabs-6") {
            initTabStats();
        } else if  (target == "ex-with-icons-tabs-7") {
            initTabExpense();
        }
    });
}

function isPushSupported() {
    let pushOK = true;
    if (!('serviceWorker' in navigator)) {
        // Service Worker isn't supported on this browser, disable or hide UI.
        console.debug("⚙️ Service Worker isn't supported on this browser, disable or hide UI.");
        pushOK = false;
    }

    if (!('PushManager' in window)) {
        // Push isn't supported on this browser, disable or hide UI.
        console.debug("⚙️ Push isn't supported on this browser, disable or hide UI.");
        pushOK = false;
    }

    return pushOK;
}

function initPush() {
    if (isPushSupported()) {
        console.debug("⚙️ webpush supported...");
        webpushCheckSubscription(curUser, environment).then(status => {
            console.log("⚙️ Webpush subscribtion status: " + status);
            if (status) {
                $('input[name="webpush"][value="yes"]').prop('checked', true);
            } else {
                $('input[name="webpush"][value="no"]').prop('checked', true);
            }
        });
    } else {
        console.debug("⚙️ Disable webpush configuration...");
        document.getElementById('webpush-config').style.display = 'none';
    }
}

const colorScheme = document.querySelector('meta[name=color-scheme]');
const styleLight = document.querySelector('link[rel=stylesheet][media*=prefers-color-scheme][media*=light]');
const styleDark = document.querySelector('link[rel=stylesheet][media*=prefers-color-scheme][media*=dark]');

function switchScheme(scheme) {
    console.log("🎨 switching to %s", scheme);
    let lightMedia;
    let darkMedia;

    if (scheme === 'auto') {
        lightMedia = '(prefers-color-scheme: light)';
        darkMedia = '(prefers-color-scheme: dark)';
    } else {
        lightMedia = (scheme === 'light') ? 'all' : 'not all';
        darkMedia = (scheme === 'dark') ? 'all' : 'not all';
    }

    console.log("🎨 light schema = %s", lightMedia);
    console.log("🎨 dark schema = %s", darkMedia);
    styleLight.media = lightMedia;
    styleDark.media = darkMedia;
}

$(document).ready(function(){

    customElements.define("member-table", UserList);
    customElements.define("push-notification-composer", PushNotificationComposer);
    customElements.define("scroll-menu", ScrollMenu);
    customElements.define("coffee-stats", CoffeeStats);
    customElements.define("transaction-ledger", TransactionLedger);
    customElements.define("dynamic-form", DynamicForm);
    customElements.define("coffee-ranking", CoffeeRanking);
    customElements.define("bottom-nav", BottomNav);
    customElements.define("user-profile", UserProfile);
    customElements.define("coffee-home", CoffeeHome);
    customElements.define("nav-row", NavRow);
    customElements.define("avatar-picker", AvatarPicker);
    customElements.define("release-notes", ReleaseNotes);
    customElements.define("notification-inbox", NotificationInbox);
    customElements.define("update-prompt", UpdatePrompt);
    customElements.define("cleanup-form", CleanupForm);

    function initTheme() {
        const switchButtons = document.querySelectorAll('.theme-switcher-button');
        console.log("🎨 Attaching events to theme-switcher (%o)", switchButtons);
        switchButtons.forEach(button => {
            button.addEventListener('click', () => {
                console.log("🎨 switching light-dark");
                const currentButton = button;
        
                switchButtons.forEach(
                    button => button.setAttribute(
                        'aria-pressed', button === currentButton
                    )
                );
        
                console.log("🎨 color-schema: %s", button.value);
                if (button.value == 'auto') {
                    colorScheme.content = "light dark";
                } else {
                    colorScheme.content = button.value;
                }
                switchScheme(button.value);

                localStorage.setItem(COFFEE_THEME_KEY, button.value);
            });
        });

        let theme = localStorage.getItem(COFFEE_THEME_KEY);
        if (theme) {
            console.log("🎨 Switching theme (%s)...", theme);
            switchScheme(theme);

            // Init switcher
            console.log("🎨 Init switcher (%s)...", theme);
            switchButtons.forEach(btn => {
                if (btn.value === theme) {
                    btn.setAttribute('aria-pressed', 'true');
                } else {
                    btn.setAttribute('aria-pressed', 'false');
                }
            });
        } else {
            console.log("🎨 Theme not specified ...");
            localStorage.setItem(COFFEE_THEME_KEY, "auto");
        }
    }

    //registerServiceWorker();
    startApp({
        swUrl:        "/sw.js",
        updatePrompt: document.getElementById("update-prompt"),
        releaseNotes: document.getElementById("rn"),
        mandatory:    false,

        getReleaseNotes: async (version) => {
            const r = await fetch(`./releases/ver-${version}`);
            return r.json(); // [{ category: "new"|"improved"|"fixed", items: [...] }]
        },

        onLogin: (label) => {
            console.log("Star login (%s)", label);
            //let coffee = new CoffeeInfo();
            //coffee.SetKey(COFFEE_INFO_KEY, info);

            start(() => {
                //console.log("🔄 Reload page to ensure new index.html is loaded.");
                //window.location.reload();
                console.log("🔄 Login done");
                showSection("home");
                userContentVisible = false;

                console.log('⏱️ CheckInterval');
                handleUpdateCheck(localStorage.getItem(COFFEE_CHECK_UPDATE_KEY) ?? false); 

                const parser = new UAParser(navigator.userAgent);
                const result = parser.getResult();
                var platform = result.browser.name + " (" + result.browser.major + ") on " + result.os.name + " " + result.os.version;
                const curVersion   = localStorage.getItem(LAST_VER_KEY);
                saveVersion(getDB(), curUser, environment, platform, curVersion)
                
            });
        },  

        showVersion: (version) => {
            try {
                console.log('#️⃣ Display version (%s)', version);
                if (import.meta.env.VITE_ENV == "PROD") {
                    document.getElementById('env-label').style.display = 'none';
                } else {
                    const span = document.querySelector('#env-label span');
                    span.innerHTML = import.meta.env.VITE_ENV + ' ' + version ;
                }
            } catch (error) {
                console.error('❌ Unable to show version (%o)', error);
            }
        },

        checkInterval: (registration) => {
            
        }
        
    });
    initTheme();
});

let curNav = "home";

function deleteMessagesHadler(e) {
    const msgId = e.detail.id;

    console.log("Delete message %d from DB", msgId);

    const db = getDB();
    deleteInboxMessage(db, curUser, environment, msgId).then(notifications => {
        console.log("Message deleted");
    });
}

function makeMessageRead(id) {
    console.log("Mark message %d as read in DB", id);

    const db = getDB();
    updateInboxMessage(db, curUser, environment, id, true).then(notifications => {
        console.log("Message made read");
    });
}

function messageHandlerRead(e) {
    makeMessageRead(e.detail.id);
}

function messageHandlerReadAll(e) {
    console.log("Mark all messages as read in DB", e.detail.ids);

    for (var i=0; i<e.detail.ids.length; i++) {
        makeMessageRead(e.detail.ids[i]);
    } 
}

function messageHandlerUnRead(e) {
    const msgId = e.detail.id;
    console.log("Mark message %d as unread in DB", msgId);

    const db = getDB();
    updateInboxMessage(db, curUser, environment, msgId, false).then(notifications => {
        console.log("Message made unread");
    });
}

function messageHandlerUpdateBadge(e) {
    console.log("Unread count:", e.detail.unreadCount);
    const nav = document.getElementById("bottom-nav");
    nav.setBadge("inbox", e.detail.unreadCount);
}

function navHandler(target) {
    curNav = target;
    if (target == "home") {
        showSection("home");

        const db = getDB();
        updateBalance(db, curUser, "#credit", "#credit-coffee");
        totCoffee(db, curUser); 
        showCoffee(db, curUser);
    } else if (target == "stats") {
        showSection("stats");

        customElements.whenDefined("coffee-stats").then(() => {
            const db = getDB();
            statsP.update(KEY_MEMBER, 365, function(n) {
                return getDayStats(db, curUser, n);
            }).then((data) => { 
                //console.log(data);
                //console.log("length: %d", Object.keys(data).length);
                let chartData = {};
                Object.keys(data).forEach(key => {
                    let cur = data[key];
        
                    chartData[cur.day] = { drank: cur.drink, offered: cur.offer, marked: cur.mark }
                });
                //console.log(chartData);
                document.getElementById("coffee-stats").title = "Statistiche";
                document.getElementById("coffee-stats").data = chartData;                
            });
        
        });
    } else if (target == "inbox") {
        getInboxMessages(getDB(), curUser, environment).then(notifications => {
            const inbox = document.getElementById("notification-inbox");
            inbox.notifications = notifications;

            const nav = document.getElementById("bottom-nav");
            nav.setBadge("inbox", inbox.unreadCount);
        });
        showSection("inbox");
    } else if (target == "admin") {
        if (me.roles.includes("admin")) {
            initAdmin();
            showSection("admin");
            
            const db = getDB();
            listUsers(db).then((members) => {
                $("#member-list-container").html(showSelectUsers(members));
            });
        } else {
            showSection("unauthorized");
        }
    } else if (target == "logout") {
        logout();

        $("#userid").html("");
        $("#message").html("");
        $("#coffee").html("");
        $("#drinkCoffeeTot").html("");
        $("#offeredCoffeeTot").html("");
    }
}

$(".navlinks").click(function(e){
    var target = e.currentTarget.getAttribute('data-target');

    navHandler(target);
});

let userContentVisible = false;
$(".user-container").click(function(e){

    if (userContentVisible) {
        console.debug("⚙️ Hide user preferences...");
        hideOverlay("home");
        userContentVisible = false;
    } else {
        
        console.log(me);
        
        // Get saved theme from localStorage
        let savedTheme = localStorage.getItem(COFFEE_THEME_KEY);
        
        const profileData = {
            // ── Read-only fields (managed by admin / backend) ──────────────────
            first_name: me.first_name,
            last_name:  me.last_name,
            email:      curUser,
            office:     me.office,
            avatar:     me.image,
            alias:      me.alias,
            cancel:     true,

            // ── User-editable preferences ──────────────────────────────────────
            coffee_icon_drank:  me.color_drink,   // icon for coffees consumed
            coffee_icon_offered: me.color_offer,   // icon for coffees offered to others
            coffee_icon_marked: me.color_mark,   // icon for coffees marked doen
            theme:         savedTheme,       // "light" | "auto" | "dark"

            links: [
                { "id": "privacy-policy", "link": "./pp.html"},
                { "id": "terms-of-service", "link": "./tos.html"},
            ]
        };
        
        if (isPushSupported()) {
            console.debug("⚙️ webpush supported...");
            webpushCheckSubscription(curUser, environment).then(status => {
                console.log("⚙️ Webpush subscribtion status: " + status);

                customElements.whenDefined("user-profile").then(() => {
                    const profile = document.getElementById("user-profile");

                    // Pass the data object
                    profileData.push = status;
                    profileData.check_updates = localStorage.getItem(COFFEE_CHECK_UPDATE_KEY) ?? false;
                    profileData.version = localStorage.getItem(LAST_VER_KEY);
                    profile.data = profileData;

                    // Customise the save button label (optional — defaults to "Save preferences")
                    profile.submitLabel = "Save settings";
                });

                
            });
        } else {
            console.debug("⚙️ Disable webpush configuration...");
            document.getElementById('webpush-config').style.display = 'none';

            const profile = document.getElementById("user-profile");

            // Pass the data object
            profileData.push = false;
            profileData.check_updates = localStorage.getItem(COFFEE_CHECK_UPDATE_KEY) ?? false;
            profileData.version = localStorage.getItem(LAST_VER_KEY);
            profile.data = profileData;

            // Customise the save button label (optional — defaults to "Save preferences")
            profile.submitLabel = "Save settings";
        }
    

    
        console.debug("⚙️ Show user preferences...")
        showOverlay("user-content");
        userContentVisible = true;
    }
});

/*
$("#offer-choose").click(function(e){
    init();
    showOverlay("offer-content");
	showPeopleToOffer(getDB(), curUser);
});

$("#offer-back").click(function(e){
    hideOverlay("home");
});
*/

function saveCredit(member, amount, action) {
    const db = getDB();
    saveAdmin(db, member, amount).then(() => { 

        getUser(db, member).then((user) => {
            let body = {
                "env": environment,
                "message": "" + amount + ".-- CHF sono stati caricati !!",
                "target": user.alias            
            };

            console.log("💰 Body = %o", body);
            authRequest("POST", "https://europe-west6-coffee-41c4a.cloudfunctions.net/api/sendPush", body)

            action();
        })
        
        
    });   
}

function saveExpense(description, amount, action) {
    console.log("Saving " + description + " - " + amount + " ...");
    const db = getDB();
    var user = curUser;
    saveExpenses(db, user, description, amount).then(action);     
}

function saveCreditHandler(e) {
    console.log("Event:", e);
    if (e.target.id == "credit-form") {
        console.log("Credit Form submitted:", e.detail);
        saveCredit(e.detail.recipient.userid, e.detail.amount, () => { });
    } else if (e.target.id == "expense-form") {
        console.log("Expense Form submitted:", e.detail);
        saveExpense(e.detail.description, e.detail.amount, () => { }) 
    }
    
}

function initTabCredit() {
    let users = [];
 
    // ── Field schema ─────────────────────────────────────────────────────
    // Each field object supports:
    //   name        {string}  — unique key, used in the submitted data object
    //   type        {string}  — "user-select" | "amount" | "text"
    //   label       {string}  — label shown above the field
    //   hint        {string}  — optional muted sub-label below the label
    //   visible     {boolean} — whether this field is rendered at all
    //   required    {boolean} — whether submitting without a value shows an error
    const fields = [
      {
        name:     "recipient",
        type:     "user-select",
        label:    "Membro",
        hint:     "Chi sta versando l'importo?",
        visible:  true,
        required: true,
      },
      {
        name:     "amount",
        type:     "amount",
        label:    "Importo (CHF)",
        hint:     "Inserire l'importo desiderato",
        visible:  true,
        required: true,
      },
    ];
 
    customElements.whenDefined("dynamic-form").then(() => {
        const db = getDB();
        listUsers(db).then((members) => {
            //console.log(members);
        
            let i = 0;
            Object.keys(members).forEach(key => {
                let cur = members[key];
                //console.log("%s => %s", key, cur.alias);
                if (cur.roles.indexOf("member") > -1) {
                    let item = { id: ++i, userid: key, name: cur.first_name, surname: cur.last_name, alias:"@" + cur.alias, avatar: cur.image }
                    users.push(item);
                }
            });
            const form = document.getElementById("credit-form");
            form.users       = users;
            form.fields      = fields;
            form.submitLabel = "Accredita importo";
        });
      
    });
 
    // Listen for form-submit events
    // e.detail = { recipient: {user obj} | null, amount: 12.50, description: "..." }
    document.removeEventListener("form-submit", saveCreditHandler);
    document.addEventListener("form-submit", saveCreditHandler);
}

function initTabExpense() {
    let users = [];
 
    // ── Field schema ─────────────────────────────────────────────────────
    // Each field object supports:
    //   name        {string}  — unique key, used in the submitted data object
    //   type        {string}  — "user-select" | "amount" | "text"
    //   label       {string}  — label shown above the field
    //   hint        {string}  — optional muted sub-label below the label
    //   visible     {boolean} — whether this field is rendered at all
    //   required    {boolean} — whether submitting without a value shows an error
    const fields = [
      {
        name:     "amount",
        type:     "amount",
        label:    "Importo (CHF)",
        hint:     "Inserire l'importo desiderato",
        visible:  true,
        required: true,
      },
      {
        name:     "description",
        type:     "text",
        label:    "Descrizione",
        hint:     "Descrizione della spesa",
        visible:  true,
        required: true,
      },
    ];
 
    customElements.whenDefined("dynamic-form").then(() => {
        
        const form = document.getElementById("expense-form");
        form.fields      = fields;
        form.submitLabel = "Registra spesa";
      
    });
 
    // Listen for form-submit events
    // e.detail = { recipient: {user obj} | null, amount: 12.50, description: "..." }
    document.removeEventListener("form-submit", saveCreditHandler);
    document.addEventListener("form-submit", saveCreditHandler);
}

function sendNotification(e) {
    console.log("Notification sent:", e.detail);    
    // e.detail = { recipient: "everyone" | { id, name, ... }, message: "..." }

    var message = e.detail.message;
    var target = e.detail.recipient.alias;
    console.log("Target = %s", target);
    let body = {
        "env": environment,
        "message": message
    };
    if (target != "*" && target != "everyone") {
        body["target"] = target;
    }
    console.log("Body = %o", body);
    authRequest("POST", "https://europe-west6-coffee-41c4a.cloudfunctions.net/api/sendPush", body)
}

function initTabPush() {
    // Push
    var dropdown = $("#admin-push-target");
    dropdown.empty();
    dropdown.append($("<option />").val("*").text("Tutti"));

    const db = getDB();
    
    let users = [];
    let i = 0;
    customElements.whenDefined("push-notification-composer").then(() => {
        listUsers(db).then((members) => {
            //console.log(members);
        
            Object.keys(members).forEach(key => {
                let cur = members[key];
                //console.log("%s => %s", key, cur.alias);
                if (cur.roles.indexOf("member") > -1) {
                    let push = false;
                    if (cur.hasOwnProperty("push") && cur.push.hasOwnProperty(environment)) {
                        const numOfSub = cur.push[environment].length;
                        console.log("✅ %s (%d)", cur.alias, numOfSub);
                        push = true;
                    } else {
                        console.log("❌ %s did not enable push", cur.alias);
                    }
                    
                    let item = { id: i++, name: cur.first_name, surname: cur.last_name, alias: cur.alias, push: push, avatar: cur.image }
                    users.push(item);
                }
            });
            document.getElementById("push-notification-composer").users = users;
        });
    });

    // Listen for the notification-send event
    document.removeEventListener("notification-send", sendNotification);
    document.addEventListener("notification-send", sendNotification); 
}

function getHighestVersion(items) {
  //console.log("🏷️ getHighestVersion %o", items);
  if (!items || items.length === 0) {
    return null;
  }

  // Compare two version strings like "1.2.1"
  function compareVersions(a, b) {
    const pa = a.split('.').map(Number);
    const pb = b.split('.').map(Number);
    const len = Math.max(pa.length, pb.length);

    for (let i = 0; i < len; i++) {
      const va = pa[i] || 0;
      const vb = pb[i] || 0;

      if (va > vb) return 1;
      if (va < vb) return -1;
    }

    return 0;
  }

  // Return the object with the highest version
  let result = items.reduce((highest, current) => {
    return compareVersions(current.ver, highest.ver) > 0
      ? current
      : highest;
  });

  //console.log("🏷️ ==> %o", result);
  return result.ver;
}

function getLastLogin(items) {
  //console.log("🏷️ getLastLogin %o", items);
  if (!items || items.length === 0) {
    return null;
  }

  // Compare two version strings like "1.2.1"
  function compareVersions(a, b) {
    const pa = a.split('.').map(Number);
    const pb = b.split('.').map(Number);
    const len = Math.max(pa.length, pb.length);

    for (let i = 0; i < len; i++) {
      const va = pa[i] || 0;
      const vb = pb[i] || 0;

      if (va > vb) return 1;
      if (va < vb) return -1;
    }

    return 0;
  }

  // Return the object with the highest version
  let result = items.reduce((highest, current) => {
    return compareVersions(current.date, highest.date) > 0
      ? current
      : highest;
  });

  console.log("🏷️ ==> %o", result);
  return result.date;
}

function initTabMembers() {
    customElements.whenDefined("member-table").then(() => {
        const list = [];
        const db = getDB();
        listUsers(db).then((members) => {
            Object.keys(members).forEach(key => {
                let cur = members[key];
                let push = false;
                if (cur.push && cur.push[environment]) {
                    push = true;
                }
                let ver = "0.0.0";
                let last;
                console.log("👥 %s (%o)", key, cur);
                if (cur.versions && cur.versions[environment]) {
                    ver = getHighestVersion(cur.versions[environment]);
                    last = getLastLogin(cur.versions[environment]);
                }
                let item = { id: key, name: cur.first_name, surname: cur.last_name, alias: cur.alias, balance: cur.balance, version: ver, lastLogin: last, push: push, avatar: cur.image }
                console.log("👥 ==> %o", item);
                list.push(item);
            })
            document.getElementById("member-table").users = list;
        });
    });
}

function initTabCoffee() {
    // Situazione odierna
    const db = getDB();
    const today = dayjs().format('YYYY-MM-DD');
    var info = stats(db, today).then((info) => {
        console.log(info);
        $("#admin-stats-table-container").html(showDayStats(info));
    });       
    
    const rankingData = {
      date: dayjs().format('YYYY-MM-DD'),
      members: [ ],
    };
 
    customElements.whenDefined("coffee-ranking").then(() => {

        const db = getDB();
        const today = dayjs().format('YYYY-MM-DD');
        var info = stats(db, today).then((info) => {
            console.log(info);

            listUsers(db).then((members) => {
                
                let i = 0;
                Object.keys(info).forEach(key => {
                    let cur = info[key];

                    if (members[key]) {
                        rankingData.members.push({ id: i, name: members[key].first_name, surname: members[key].last_name, alias:"@" + members[key].alias,   avatar: members[key].image, drank:cur.drink, offered: cur.offer },)
                    } 
                });

                document.getElementById("coffee-ranking").data = rankingData;
            });        
        }); 
    });
 
    // Listen for member-select events
    //document.addEventListener("ranking-select", (e) => {
    //  console.log("Selected member:", e.detail);
    //});
}

function initTabBalance() {
    // Bilancio
    const db = getDB();
    customElements.whenDefined("transaction-ledger").then(() => {
        var expenses = getExpenses(db);
        getExpenses(db).then((doc) => { 
            const movements = [];
            for (var i=0; i<doc.length; i++) { 
                var date = dayjs(doc[i].created_at).format('YYYY-MM-DD');
                var amount = Number(doc[i].amount)*10;
                let type = "payment";
                if (Math.sign(amount) < 0) {
                    type = "expense";
                }
                let obj = { id: i, date: date, type: type, description: doc[i].description, amount: doc[i].amount};
                movements.push(obj);
            }
            console.log("movements (%d): %o", doc.length, movements);
            document.getElementById("transaction-ledger").movements = movements;
        });
      
    });
 
    // Listen for row-select events
    //document.addEventListener("ledger-select", (e) => {
    //  console.log("Selected movement:", e.detail);
    //});
}

function initTabStats() {
    // Statst
    customElements.whenDefined("coffee-stats").then(() => {
        const db = getDB();
        statsP.update(KEY_ADMIN, 365, function(n) {
            return getAdminStats(db, "", n);
        }).then((data) => { 
            //console.log(data);
            let chartData = {};
            Object.keys(data).forEach(key => {
                let cur = data[key];
    
                chartData[cur.day] = { drank: cur.drink, offered: cur.offer, marked: cur.mark }
            });
            //console.log(chartData);
            document.getElementById("coffee-stats-admin").title = "Statistiche globali";
            document.getElementById("coffee-stats-admin").data = chartData;
        });
      
    });
}

$(".nav-link").click(function(e){
    var target = e.currentTarget.getAttribute('data-target');

    console.log(target);
    showAdminTab(target);

    if (target == "ex-with-icons-tabs-2") {
        initTabPush();
    } else if (target == "ex-with-icons-tabs-3") {
        initTabCoffee();   
    } else if (target == "ex-with-icons-tabs-4") {
        initTabMembers();
    } else if (target == "ex-with-icons-tabs-5") {
        initTabBalance();
    } else if  (target == "ex-with-icons-tabs-6") {
        initTabStats();
    }
});

function handlePush(status) {
    if (status) {
        Notification.requestPermission().then((permission) => {
            if (permission == "granted") {
                console.log("💬 permission granted (%s)", permission);
                try {
                    webpushCheckSubscription(curUser, environment).then(status => {
                        if (!status) {
                            console.log("💬 Start subscribing ");
                            webpushSubscribeUser(curUser, environment);
                        } else {
                            console.log("💬 Subscription was ok");
                        }
                    })
                } catch (error) {
                    console.error(error);
                }
            } else {
                console.log("💬 permission %s", permission);
            }
        });
    } else {
        try {
            webpushUnsubscribeUser(curUser, environment);
        } catch (error) {
            console.error(error);
        }
    }
}

function handleUpdateCheck(status) {
    if (status) {
        console.log("✅ Enabling version checks ...");
        const db = getDB();
        getUser(db, curUser).then((me) =>  {
            if (me.roles.includes("admin")) {
                localStorage.setItem(COFFEE_CHECK_UPDATE_KEY, UPDATE_CHECK_PERIOD_ADMIN);
            } else {
                localStorage.setItem(COFFEE_CHECK_UPDATE_KEY, UPDATE_CHECK_PERIOD_DEFAULT);
            }
            navigator.serviceWorker.ready.then((registration) => {
                updateCheckId = setInterval(() => {
                    console.log("✅ Checking for update on the server");
                    registration.update();
                }, localStorage.getItem(COFFEE_CHECK_UPDATE_KEY)); 
            });
        });
    } else {
        console.log("✅ Disabling version checks ...");
        localStorage.removeItem(COFFEE_CHECK_UPDATE_KEY);
        if (updateCheckId) {
            clearInterval(updateCheckId);
        }
    }
}

function sleep(time) {
    return new Promise((resolve) => setTimeout(resolve, time));
}

console.debug("hover support: %o", window.matchMedia("(hover: hover)").matches)
if (!window.matchMedia("(hover: hover)").matches) {
    const buttons = document.querySelectorAll('.btn-custom');
    if (buttons) {
        buttons.forEach((cur) => {
            console.debug("Adding click event to %o", cur);
            cur.addEventListener('click', () => {
                var style = window.getComputedStyle(document.body);
                var theme = style.getPropertyValue('--coffee-style');
                console.log( "THEME: '%s'",  theme);
                
                const className = "btn-custom-mobileclick";

                console.debug("Adding style for hover (%s, %o) ...", className, cur);
                cur.classList.add(className);
                sleep(400).then(() => {
                    console.debug("Removing style for hover (%s, %o) ...", className, cur);
                    cur.classList.remove(className);
                });
            });
        });
    }
}

$(".news-show").click(function(e){
    const rn = document.getElementById("rn");
    rn.mode    = "onboarding";
    rn.version = localStorage.getItem(LAST_VER_KEY);
    rn.last = "Ok";
    rn.open();    
});

function clean(actions) {
    if (actions.cache) {
        console.log("Clearing cache content ...");
        navigator.serviceWorker.getRegistrations().then(function(registrations) {
            for(let registration of registrations) {
                if (registration.active) {
                    registration.active.postMessage({ type: 'CLEAR_CACHE' });
                }   
            };
        });
    }

    if (actions.localStorage) {
        console.log("Clearing localSorage ...");
        localStorage.removeItem(COFFEE_THEME_KEY);
        localStorage.removeItem(COFFEE_CHECK_UPDATE_KEY);
        localStorage.removeItem(LAST_VER_KEY);
    }

    if (actions.sessionStorage) {
        console.log("Clearing sessionStorage ...");
        sessionStorage.clear();
    }

    if (actions.userStats) {
        console.log("Clearing user stats ...");
        statsP.remove(KEY_MEMBER);
    }

    if (actions.adminStats) {
        console.log("Clearing admin stats ...");
        statsP.remove(KEY_ADMIN);
    }    
}

$("#minesweeper-show").click(function(e){
    console.info("🎮 Start playing ...");

    createBoard();
    showSection("minesweeper", { "display": "flex" } );
});

$("#minesweeper-end").click(function(e){
    showSection("home" );
});

$("#minesweeper-restart").click(function(e){
    createBoard();
});

$("#minesweeper-help").click(function(e){
    help();
});



function authRequest(method, url, body) {
    return getToken().then(token => {
        //console.log("TOKEN: %s", token);

        var request = {
            method: method,
            url: url,
            //dataType: 'json',
            crossDomain: true,
            beforeSend: function(xhr) { 
                xhr.setRequestHeader('Authorization', 'Bearer ' + token); 
            },
        };

        if (method === 'POST') {
            request.contentType = 'application/json';
            request.data = JSON.stringify(body);
        }

        console.log('🌐 Making authenticated request:', method, url);
        return $.ajax(request).done( (data) => {
            console.log('🌐 OK: request sent !! (%o)', data);
            return data;
        }).fail((jqXHR, status) => {
            console.log('🌐 ERROR: %s', status);
            throw new Error('Request error: ' + method + ' ' + url);
        });
    });
}

//$("#send").click(function(){
//    //authRequest("POST", "http://127.0.0.1:5001/coffee-41c4a/us-central1/api/sendNotification", {
//    authRequest("POST", "https://europe-west6-coffee-41c4a.cloudfunctions.net/api/sendNotification", {
//        "env": environment,
//        "target": [
//            "\"Giannone TEST\"",
//            "Il Dittatore"
//        ]
//    })
//});
//
//$("#admin-push-send").click(function(){
//    var message = $('textarea#admin-push-msg').val();
//    var target = $('#admin-push-target').find(":selected").val();
//    console.log("Target = %s", target);
//    let body = {
//        "env": environment,
//        "message": message
//    };
//    if (target != "*") {
//        body["target"] = target;
//    }
//    console.log("Body = %o", body);
//    authRequest("POST", "https://europe-west6-coffee-41c4a.cloudfunctions.net/api/sendPush", body)
//});

/*
$(document).on("click", ".personToOfferContainer", function () {
    const avatar = $(this).find(".person-to-offer, .person-to-offer-selected");
	const alias = $(this).find("p");
	if (avatar.hasClass("person-to-offer")) {
        avatar.removeClass("person-to-offer").addClass("person-to-offer-selected");
		alias.addClass("person-to-offer-text-selected");
    } else {
        avatar.removeClass("person-to-offer-selected").addClass("person-to-offer");
		alias.removeClass("person-to-offer-text-selected");
    }
});
*/

//navigator.serviceWorker.ready.then(() => {
//  console.log("✅✅✅✅✅✅✅✅  READY OK ✅✅✅✅✅✅✅✅");
//  console.log("⚙️⚙️⚙️⚙️⚙️⚙️⚙️⚙️ %o", navigator.serviceWorker.controller);
//
//  askInfo();
//});



function initNavBottom() {
    const navItems = [
      { id: "home",     label: t("home"),     icon: "home",     active: true                            },
      { id: "stats",    label: t("stats"),    icon: "stats",                                            },
      { id: "inbox",    label: t("messages"), icon: "messages",                              badge: 0   },
      { id: "admin",    label: t("admin"),    icon: "admin",                  role: "admin"             },
      { id: "logout",   label: t("logout"),   icon: "logout"                                            },
    ];
 
    customElements.whenDefined("bottom-nav").then(() => {
      const nav = document.getElementById("bottom-nav");
      nav.items = navItems;
      
      // ── Attach per-item handlers ─────────────────────────────────────────
      // Option A: listen on the component for the custom event
      nav.addEventListener("nav-select", (e) => {
        const { id, label } = e.detail;
        console.log("nav-select: %o", e.detail);
        navHandler(id);
      });
 
      // Option B: register handlers directly on the component instance
      // nav.onSelect("logout", () => { /* confirm and sign out */ });
      // nav.onSelect("home",   () => { router.push("/home"); });
    });
}


$(document).ready(function(){
    
    // Listen for user-notify events
    document.addEventListener("user-notify", (e) => {
        console.log("User notify:", e.detail);

        let body = {
            "env": environment,
            "message": "Il tuo credito attuale è di " + e.detail.balance + " CHF. Il 'Dittatore' ti aspetta per saldare il tuo debito 💰💰💰!!",
            "target": e.detail.alias            
        };

        console.log("💰 Body = %o", body);
        authRequest("POST", "https://europe-west6-coffee-41c4a.cloudfunctions.net/api/sendPush", body)
    });

    initNavBottom();

    // Handle immediate push notification toggle (for iOS permission request)
    // This event fires immediately when the toggle is clicked, not on save
    document.addEventListener("profile-push-toggle", async (e) => {
      const { enabled, toggleElement } = e.detail;
      console.log("Push toggle clicked, enabled:", enabled);
      
      if (enabled) {
        try {
          // Request permission immediately (within user gesture)
          const permission = await Notification.requestPermission();
          console.log("Notification permission:", permission);
          
          if (permission === "granted") {
            // Dispatch success event to clear any warnings
            e.target.dispatchEvent(new CustomEvent("profile-push-success", {
              bubbles: true,
              composed: true
            }));
            
            // Subscribe to web push
            if (curUser && environment) {
              webpushCheckSubscription(curUser, environment).then(status => {
                if (!status) {
                  webpushSubscribeUser(curUser, environment);
                }
              });
            }
          } else {
            // Permission denied or dismissed - revert toggle
            toggleElement.checked = false;
            
            // Dispatch error event to show warning
            e.target.dispatchEvent(new CustomEvent("profile-push-error", {
              detail: { 
                message: permission === "denied" 
                  ? "Notifications blocked. Enable in browser settings." 
                  : "Permission denied"
              },
              bubbles: true,
              composed: true
            }));
          }
        } catch (error) {
          console.error("Error requesting notification permission:", error);
          toggleElement.checked = false;
          
          e.target.dispatchEvent(new CustomEvent("profile-push-error", {
            detail: { message: "Unable to request permission" },
            bubbles: true,
            composed: true
          }));
        }
      } else {
        // User is disabling push notifications
        if (curUser && environment) {
          webpushUnsubscribeUser(curUser, environment);
        }
        
        // Dispatch success event to clear any warnings
        e.target.dispatchEvent(new CustomEvent("profile-push-success", {
          bubbles: true,
          composed: true
        }));
      }
    });

     document.addEventListener("profile-updates-toggle", async (e) => {
        const { enabled, toggleElement } = e.detail;
        console.log("Check for updates toggle clicked, enabled:", enabled);
      
        handleUpdateCheck(enabled);
     });
    

    // Handle theme changes from user-profile component (immediate application)
    document.addEventListener("profile-theme-change", (e) => {
        console.log("Theme changed:", e.detail.theme);
        const theme = e.detail.theme;
        
        // Apply the theme immediately
        switchScheme(theme);
        
        // Update color-scheme meta tag
        if (theme == 'auto') {
            colorScheme.content = "light dark";
        } else {
            colorScheme.content = theme;
        }
        
        // Save to localStorage
        console.log("🎨 Saving theme (%s) ...", theme);
        localStorage.setItem(COFFEE_THEME_KEY, theme);
    });

    // Register handler for user-profile web-component
    // Fired when the user clicks save
    // e.detail = { coffee_icon_drank, coffee_icon_offered, theme, push, check_updates, avatar? }
    document.addEventListener("profile-save", (e) => {
        console.log("Profile saved:", e.detail);
        hideOverlay(curNav);
        userContentVisible = false;

        // Note: push notifications are now handled immediately on toggle
        // Theme is also handled immediately on toggle via profile-theme-change
        // We still handle check_updates and coffee icons here
        handleUpdateCheck(e.detail.check_updates);
        changeColorPod(getDB(), curUser, "drink", e.detail.coffee_icon_drank);
        changeColorPod(getDB(), curUser, "offer", e.detail.coffee_icon_offered);
        changeColorPod(getDB(), curUser, "mark", e.detail.coffee_icon_marked);

        const db = getDB();
        saveAvatarImg(db, curUser, e.detail.avatar);
        

        me.color_drink = e.detail.coffee_icon_drank;
        me.color_offer = e.detail.coffee_icon_offered;
        me.color_mark = e.detail.coffee_icon_marked;
        me.image = e.detail.avatar;

        const home = document.getElementById("coffee-home");
        home.images = {
            "drank": getPodImage(me.color_drink),
            "offered": getPodImage(me.color_offer), 
            "marked":  getPodImage(me.color_mark), 
        };

        document.querySelectorAll('.user-img').forEach((cur) => {
            cur.src = e.detail.avatar;
            cur.classList.remove('default');
        });
        
    });

    
    document.addEventListener("profile-color-change", (e) => {
        console.log("Profile color changed:", e.detail);
        
        changeColorPod(getDB(), curUser, "drink", e.detail.coffee_icon_drank);
        changeColorPod(getDB(), curUser, "offer", e.detail.coffee_icon_offered);
        changeColorPod(getDB(), curUser, "mark", e.detail.coffee_icon_marked);

        const db = getDB();
        me.color_drink = e.detail.coffee_icon_drank;
        me.color_offer = e.detail.coffee_icon_offered;
        me.color_mark = e.detail.coffee_icon_marked;
        
        const home = document.getElementById("coffee-home");
        home.images = {
            "drank": getPodImage(me.color_drink),
            "offered": getPodImage(me.color_offer), 
            "marked":  getPodImage(me.color_mark), 
        };
    });

    document.addEventListener("profile-cancel", (e) => {
        console.log("Profile cancel:", e.detail);
        hideOverlay(curNav);
        userContentVisible = false;
    });

    document.addEventListener("clean-cache", (e) => {
        console.log("Intercept clean-cache action:", e.detail);
        clean(e.detail);
    });

    document.addEventListener("open-release-note", (e) => {
        console.log("Intercept open-release-note action:", e.detail);

        const rn = document.getElementById("rn");
        rn.mode    = "onboarding";
        rn.version = localStorage.getItem(LAST_VER_KEY);
        rn.last = "Ok";
        rn.open();
    });
    
    // Fired immediately when the user applies a crop
    // e.detail = { dataUrl: "data:image/jpeg;base64,…" }
    document.addEventListener("profile-avatar", (e) => {
        console.log("New avatar:", e.detail.dataUrl.slice(0, 60) + "…");
    });

    
    document.addEventListener("avatar-change", (e) => {
        console.log("Avatar changed:", e.detail);

        const db = getDB();
        saveAvatarImg(db, curUser, e.detail.base64);

        document.querySelectorAll('.user-img').forEach((cur) => {
            cur.src = e.detail.base64;
            cur.classList.remove('default');
        });
    });

    const homeData = {
      // User info
      //user: {
      //  name:    "Sophie M.",
      //  avatar:  "https://i.pravatar.cc/96?img=5",
      //},

      // App meta
      //version: "1.2.3",

      // Financial
      //balance:    1344.80,   // CHF
      coffee_price: 0.80,    // CHF per coffee

      // Today's counts (pre-loaded from backend)
      drank_today:   1,
      offered_today: 2,
      marked_today: 3,

      // Icon preferences (from user-profile component)
      mode: "images",

      // Button labels (all customisable)
      label_drank:   "Paga",
      label_offered: "Offri",
      label_marked: "Marca",
      label_balance: "Il tuo saldo",
    };

    customElements.whenDefined("coffee-home").then(() => {
      document.getElementById("coffee-home").data = homeData;
    });

    // Fired when user logs a coffee (before confirmation window expires)
    // e.detail = { type: "drank"|"offered", balance_after: 1344.00, id: 3 }
    document.addEventListener("coffee-log", (e) => {
      console.log("Coffee logged:", e.detail);
      if (e.detail.type === "drank") {
        const db = getDB();

        console.log("☕ Paying 1 coffee ...");
        payCoffee(db, curUser, 1, "drink").then((id) => {
            const info = { id: e.detail.id, key: id };
            console.log("info: %o", info);
            const home = document.getElementById("coffee-home");
            home.updateCoffeId = info
        });
      } else if (e.detail.type === "offered") {
        const db = getDB();

        console.log("☕ Offer 1 coffee ...");
        payCoffee(db, curUser, 1, "offer").then((id) => {
            const info = { id: e.detail.id, key: id };
            console.log(info);
            const home = document.getElementById("coffee-home");
            home.updateCoffeId = info
        });

        //totCoffee(db, curUser).then(tot => {
        //    if (tot.totOffer >= PRICE) {
        //        $("#minesweeper-show").css("display", "block");
        //    }
        //});
      } else {
        console.log("Event:", e);
        console.log("Event:", e.currentTarget);
        const db = getDB();
        createCoffee(db, curUser, "mark").then((id) => {
            const info = { id: e.detail.id, key: id };
            console.log(info);
            const home = document.getElementById("coffee-home");
            home.updateCoffeId = info
        });
        
      }
    });

    // Fired when user cancels a pending coffee via capsule click
    // e.detail = { type: "drank"|"offered", balance_after: 1344.80, id: 3 }
    document.addEventListener("coffee-undo", (e) => {
        console.log("Coffee undone:", e.detail);

        let id = e.detail.key;
        console.log("☕ Deleting coffee from " + id + " ...");
        
        const db = getDB();
        deleteCoffee(db, curUser, id).then(() => {
            totCoffee(db, curUser).then(tot => {
                if (tot.totOffer < PRICE) {
                    $("#minesweeper-show").css("display", "none");
                }
            });
        })
    });

    customElements.whenDefined("notification-inbox").then(() => {
        const inbox = document.getElementById("notification-inbox");


        // ── Event: fired whenever unread count changes ──────────────────────
        // Use this to drive your bottom-nav badge.
        // e.detail = { unreadCount: 3 }
        inbox.removeEventListener("unread-count-change", messageHandlerUpdateBadge);
        inbox.addEventListener("unread-count-change", messageHandlerUpdateBadge);
            

        // ── Event: fired when a notification is opened/read ─────────────────
        // Persist the change to your DB here.
        // e.detail = { id, title, body, ts, read: true, ... }
        inbox.removeEventListener("notification-read", messageHandlerRead);
        inbox.addEventListener("notification-read", messageHandlerRead);
        inbox.removeEventListener("notification-unread", messageHandlerUnRead);
        inbox.addEventListener("notification-unread", messageHandlerUnRead);

        // ── Event: fired when a notification is deleted ─────────────────────
        // e.detail = { id }
        inbox.removeEventListener("notification-delete", deleteMessagesHadler);
        inbox.addEventListener("notification-delete", deleteMessagesHadler);

        // ── Event: fired when "Mark all as read" is triggered ───────────────
        // e.detail = { ids: [1, 2, 3, ...] }  — only previously-unread IDs
        inbox.removeEventListener("notification-read-all", messageHandlerReadAll);
        inbox.addEventListener("notification-read-all", messageHandlerReadAll);
    });

    //document.addEventListener('visibilitychange', () => {
    //    if (document.visibilityState === 'visible') {
    //        console.info('👀 Visibility changed to visible');
    //                    
    //        getInboxMessages(getDB(), curUser, environment).then(notifications => {
    //            const inbox = document.getElementById("notification-inbox");
    //            inbox.notifications = notifications;
    //
    //            const nav = document.getElementById("bottom-nav");
    //            nav.setBadge("inbox", inbox.unreadCount);
    //        });
    //    }
    //});

    document.addEventListener("cleanup-run", (e) => {
        console.log("🧽 cleanup-run:", e.detail);
        clean(e.detail);

        let cleanId = setInterval(() => {
                    console.log("❎ Closing row");
                    // Close the nav-row overlay so the user-profile comes back
                    // nav-row lives inside the user-profile's shadow DOM
                    const profile = document.getElementById("user-profile");
                    if (profile && profile.shadowRoot) {
                        const navRow = profile.shadowRoot.getElementById("rowCleanup");
                        if (navRow) navRow.close();
                    }
                    clearInterval(cleanId);
                }, 2000); 
        
    });
});